import React from 'react';
import { Plane, Map, BriefcaseBusiness } from 'lucide-react';

/**
 * Компонент секции параметров авиакомпании и полета
 */
const AirlineParamsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  airlinesData,
  travelClasses,
  destinationTypes
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Авиакомпания */}
      <div>
        <label htmlFor="airline" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Plane className="w-4 h-4 mr-2 text-purple-500" />
          Авиакомпания
        </label>
        <select
          id="airline"
          name="airline"
          value={formData.airline}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.airline ? 'input-error' : ''}`}
        >
          {airlinesData.map((airline) => (
            <option key={airline.id} value={airline.id}>
              {airline.name}
            </option>
          ))}
        </select>
        {errors.airline && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.airline}
          </p>
        )}
      </div>

      {/* Класс обслуживания */}
      <div>
        <label htmlFor="travelClass" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <BriefcaseBusiness className="w-4 h-4 mr-2 text-purple-500" />
          Класс обслуживания
        </label>
        <select
          id="travelClass"
          name="travelClass"
          value={formData.travelClass}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.travelClass ? 'input-error' : ''}`}
        >
          {travelClasses.map((travelClass) => (
            <option key={travelClass.id} value={travelClass.id}>
              {travelClass.name}
            </option>
          ))}
        </select>
        {errors.travelClass && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.travelClass}
          </p>
        )}
      </div>

      {/* Тип направления */}
      <div className="col-span-full">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
          <Map className="w-4 h-4 mr-2 text-purple-500" />
          Тип направления
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          {destinationTypes.map((destination) => (
            <label key={destination.id} className="inline-flex items-center">
              <input
                type="radio"
                name="destinationType"
                value={destination.id}
                checked={formData.destinationType === destination.id}
                onChange={handleInputChange}
                className="form-radio"
              />
              <div className="ml-2">
                <span className="text-sm text-gray-700 dark:text-gray-300">
                  {destination.name}
                </span>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {destination.description}
                </p>
              </div>
            </label>
          ))}
        </div>
        {errors.destinationType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.destinationType}
          </p>
        )}
      </div>
    </div>
  );
};

export default AirlineParamsSection;